// extracted by mini-css-extract-plugin
export default {"root":"IrbUoT","spotifyFrame":"Etatvy","rootInEditor":"uFsP7h","rootInViewer":"taEZRK"};